import { writable } from "svelte/store";

const InvestigateDataGapsStore = {
	enabled: writable(false),
	gapLength: writable(24)
};
export default InvestigateDataGapsStore;
